export const undoConstants = {
    MAX_UNDO_ENTRIES: 30,

    PUSH_UNDO: 'PUSH_UNDO',
    CLEAR_UNDO: 'CLEAR_UNDO',

    UNDO_REQUEST: 'UNDO_REQUEST',
    UNDO_SUCCESS: 'UNDO_SUCCESS',
    UNDO_FAILURE: 'UNDO_FAILURE',
};
